var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-select', {
    ref: "remoteSelect",
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getRemoteData,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder
    },
    on: {
      "clear": function clear($event) {
        return _vm.getRemoteData('');
      },
      "focus": function focus($event) {
        return _vm.getRemoteData('');
      },
      "change": _vm.handleChange
    },
    model: {
      value: _vm.internalValue,
      callback: function callback($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }, _vm._l(_vm.dataList, function (item, index) {
    return _c('el-option', {
      key: "business-info-remote-".concat(index, "-").concat(item.businessNo),
      attrs: {
        "label": "".concat(item.businessNo, "-").concat(item.companyName),
        "value": item.businessNo
      }
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }